export const sumarTiempos = (transacciones) => {
    return calcular(transacciones?.map(transaccion => transaccion?.tiempo_atencion));
}

const calcular = (arreglo) => {
    // Convertir los tiempos del array a milisegundos
    const nuevoArr = arreglo?.map(a => tiempoASegundos(a) * 1000);
    // Sumar los tiempos del array en milisegundos
    let tiempoTotalMs = nuevoArr.reduce((a, b) => a + b, 0);

    // Convertir el tiempo total de vuelta a un formato de tiempo
    return segundosATiempo(tiempoTotalMs / 1000);
}
  
  // Función para convertir un tiempo en formato hh:mm:ss a segundos
  const tiempoASegundos = (tiempo) => {
    let partesTiempo = tiempo.split(":");
    return (+partesTiempo[0]) * 60 * 60 + (+partesTiempo[1]) * 60 + (+partesTiempo[2]);
  }
  
  // Función para convertir segundos a formato de tiempo hh:mm:ss
  const segundosATiempo = (seg) => {
    let horas = Math.floor(seg / 3600);
    let minutos = Math.floor((seg - (horas * 3600)) / 60);
    let segundos = Math.floor(seg - (horas * 3600) - (minutos * 60));
  
    // Asegurarse de que haya dos dígitos en la hora, minutos y segundos
    horas = (horas < 10 ? "0" : "") + horas;
    minutos = (minutos < 10 ? "0" : "") + minutos;
    segundos = (segundos < 10 ? "0" : "") + segundos;
  
    return horas + ":" + minutos + ":" + segundos;
  }